export const LOGOUT_USER = 'LOGOUT_USER'
export const LOGIN_USER = 'LOGIN_USER'



// WEBPACK FOOTER //
// ./src/store/modules/user/types.js